import React from 'react';
import { useState, useEffect } from 'react';
import StackedBarChart from './StackedBarChart';

export default ({ type, chartType, lifespan, biogenicCarbon, ready, data, selectedData, metaData, units }) => {
    if(ready !== true) {
        return null;
    }

    
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [barHeight, setBarHeight] = useState(40); 
  
    useEffect(() => {
      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    useEffect(() => {
      if (screenWidth < 699) {
        setBarHeight(15);
      } else if (screenWidth > 700 && screenWidth < 1119) {
        setBarHeight(25);
      } else {
        setBarHeight(40);
      }
    }, [screenWidth]);

    const gwpUnit = units?.gwpUnit ?? "kgCO₂eq/sf";
    const gwpAxisLabel = `GWP (${gwpUnit})`;

    
         
    return <div style={{ width: "100%"}}>
      {/* GLOBAL WARMING POTENTIAL */}
      {chartType === "GWP" && data.gwpData.length > 0 && lifespan === "tenY" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData}
        allMaterials={data.gwpData}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="material"
        currentChart={chartType}
      />}

      {/* ALL IMPACTS*/}
      {chartType === "allImpacts" && selectedData.allImpactsData.length > 0 && lifespan === "tenY" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.allImpactsData}
        allMaterials={data.allImpactsData}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel="Normalized % of Total"
        currentChart={chartType}
      />}

      {/* LIFE CYCLE STAGE */}
      {chartType === "LCS" && selectedData.lcsData.length > 0 && lifespan === "tenY" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.lcsData}
        allMaterials={data.lcsData}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* MATERIAL BREAKDOWN */}
      {chartType === "MB" && selectedData.materialData.length > 0 && lifespan === "tenY" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.materialData}
        allMaterials={data.materialData}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* GLOBAL WARMING POTENTIAL */}
      {chartType === "GWP" && data.gwpData1.length > 0 && lifespan === "tenY" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData1}
        allMaterials={data.gwpData1}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="material"
        currentChart={chartType}
      />}

      {/* ALL IMPACTS*/}
      {chartType === "allImpacts" && selectedData.allImpactsData1.length > 0 && lifespan === "tenY" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.allImpactsData1}
        allMaterials={data.allImpactsData1}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel="Normalized % of Total"
        currentChart={chartType}
      />}

      {/* LIFE CYCLE STAGE */}
      {chartType === "LCS" && selectedData.lcsData1.length > 0 && lifespan === "tenY" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.lcsData1}
        allMaterials={data.lcsData1}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* MATERIAL BREAKDOWN */}
      {chartType === "MB" && selectedData.materialData1.length > 0 && lifespan === "tenY" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.materialData1}
        allMaterials={data.materialData1}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* GLOBAL WARMING POTENTIAL */}
      {chartType === "GWP" && data.gwpData2.length > 0 && lifespan === "sixty1" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData2}
        allMaterials={data.gwpData2}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="material"
        currentChart={chartType}
      />}

      {/* ALL IMPACTS*/}
      {chartType === "allImpacts" && selectedData.allImpactsData2.length > 0 && lifespan === "sixty1" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.allImpactsData2}
        allMaterials={data.allImpactsData2}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel="Normalized % of Total"
        currentChart={chartType}
      />}

      {/* LIFE CYCLE STAGE */}
      {chartType === "LCS" && selectedData.lcsData2.length > 0 && lifespan === "sixty1" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.lcsData2}
        allMaterials={data.lcsData2}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* MATERIAL BREAKDOWN */}
      {chartType === "MB" && selectedData.materialData2 && lifespan === "sixty1" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.materialData2}
        allMaterials={data.materialData2}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* GLOBAL WARMING POTENTIAL */}
      {chartType === "GWP" && data.gwpData3.length > 0 && lifespan === "sixty1" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData3}
        allMaterials={data.gwpData3}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="material"
        currentChart={chartType}
      />}

      {/* ALL IMPACTS*/}
      {chartType === "allImpacts" && selectedData.allImpactsData3.length > 0 && lifespan === "sixty1" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.allImpactsData3}
        allMaterials={data.allImpactsData3}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel="Normalized % of Total"
        currentChart={chartType}
      />}

      {/* LIFE CYCLE STAGE */}
      {chartType === "LCS" && selectedData.lcsData3.length > 0 && lifespan === "sixty1" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.lcsData3}
        allMaterials={data.lcsData3}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* MATERIAL BREAKDOWN */}
      {chartType === "MB" && selectedData.materialData3.length > 0 && lifespan === "sixty1" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.materialData3}
        allMaterials={data.materialData3}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* GLOBAL WARMING POTENTIAL */}
      {chartType === "GWP" && data.gwpData4.length > 0 && lifespan === "sixty2" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData4}
        allMaterials={data.gwpData4}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="material"
        currentChart={chartType}
      />}

      {/* ALL IMPACTS*/}
      {chartType === "allImpacts" && selectedData.allImpactsData4.length > 0 && lifespan === "sixty2" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.allImpactsData4}
        allMaterials={data.allImpactsData4}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel="Normalized % of Total"
        currentChart={chartType}
      />}

      {/* LIFE CYCLE STAGE */}
      {chartType === "LCS" && selectedData.lcsData4.length > 0 && lifespan === "sixty2" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.lcsData4}
        allMaterials={data.lcsData4}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* MATERIAL BREAKDOWN */}
      {chartType === "MB" && selectedData.materialData4.length > 0 && lifespan === "sixty2" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.materialData4}
        allMaterials={data.materialData4}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* GLOBAL WARMING POTENTIAL */}
      {chartType === "GWP" && data.gwpData5.length > 0 && lifespan === "sixty2" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData5}
        allMaterials={data.gwpData5}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="material"
        currentChart={chartType}
      />}

      {/* ALL IMPACTS*/}
      {chartType === "allImpacts" && selectedData.allImpactsData5.length > 0 && lifespan === "sixty2" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.allImpactsData5}
        allMaterials={data.allImpactsData5}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel="Normalized % of Total"
        currentChart={chartType}
      />}

      {/* LIFE CYCLE STAGE */}
      {chartType === "LCS" && selectedData.lcsData5.length > 0 && lifespan === "sixty2" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.lcsData5}
        allMaterials={data.lcsData5}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* MATERIAL BREAKDOWN */}
      {chartType === "MB" && selectedData.materialData5.length > 0 && lifespan === "sixty2" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.materialData5}
        allMaterials={data.materialData5}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        currentChart={chartType}
      />}

      {/* MATERIAL HEALTH */}
      {chartType === "MH" && data.gwpData.length > 0 && lifespan === "tenY" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData}
        allMaterials={data.gwpData}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="health"
        currentChart={chartType}
      />}

      {/* MATERIAL HEALTH */}
      {chartType === "MH" && data.gwpData1.length > 0 && lifespan === "tenY" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData1}
        allMaterials={data.gwpData1}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="health"
        currentChart={chartType}
      />}

      {/* MATERIAL HEALTH */}
      {chartType === "MH" && data.gwpData2.length > 0 && lifespan === "sixty1" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData2}
        allMaterials={data.gwpData2}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="health"
        currentChart={chartType}
      />}

      {/* MATERIAL HEALTH */}
      {chartType === "MH" && data.gwpData3.length > 0 && lifespan === "sixty1" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData3}
        allMaterials={data.gwpData3}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="health"
        currentChart={chartType}
      />}

      {/* MATERIAL HEALTH */}
      {chartType === "MH" && data.gwpData4.length > 0 && lifespan === "sixty2" && biogenicCarbon === "nBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData4}
        allMaterials={data.gwpData4}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="health"
        currentChart={chartType}
      />}

      {/* MATERIAL HEALTH */}
      {chartType === "MH" && data.gwpData5.length > 0 && lifespan === "sixty2" && biogenicCarbon === "yBio" && <StackedBarChart type={type}
        unitTrail={units?.gwpUnit}
        selectedMaterials={selectedData.gwpData5}
        allMaterials={data.gwpData5}
        metaData={metaData}
        barHeight={barHeight}
        xAxisLabel={gwpAxisLabel}
        colorBy="health"
        currentChart={chartType}
      />}
    </div>;
};